/** Persist an explicit sibling order, repairing missing, tied, or exhausted ranks. */
export function orderChanges(items: readonly { id: string; sortOrder?: number | undefined }[]) {
  return items.flatMap((item, index) => {
    const sortOrder = (index + 1) * 1024;
    return item.sortOrder === sortOrder ? [] : [{ id: item.id, sortOrder }];
  });
}
